import React, { useCallback, useReducer, useMemo, useEffect } from "react";
import PickUp from "../../drag-drop-template/pick-up";
import DropZone from "../../drag-drop-template/drop-zone";
import './style.scss';

type Props = {
    onComplete?: () => void
}

type Item = {
    value: string
}

type Basket = {
    id: string,
    answer?: string,
    items: string[],
    description: string
}

type GameState = {
    baskets: Basket[],
    items: Item[]
}

const TaskGame9: React.FunctionComponent<Props> = ({ onComplete }) => {

    const [gameData, moveEgg] = useReducer((state: GameState, { itemId, basket }: { itemId: string, basket: string }) => {
        return {
            ...state,
            baskets: state.baskets.map(b => {

                const items = b.items.filter(i => i !== itemId);

                if (b.id === basket) {
                    if (state.items.find(i => i.value === itemId)) {
                        items[0] = itemId;
                    }
                }

                return {
                    ...b,
                    items
                }
            })
        }
    }, {
        baskets: [
            {
                id: 'b1',
                answer: 'dostrzeganie i akceptowanie różnicy jako faktu',
                items: [],
                description: `niedostrzeganie i umniejszanie różnic`
            },
            {
                id: 'b2',
                answer: 'zrozumienie, że wszyscy są ważni i akceptowani we wspólnocie',
                items: [],
                description: `myślenie My - Oni`
            },
            {
                id: 'b3',
                answer: 'tworzenie przestrzeni i atmosfery zaufania, w której możesz powiedzieć, co myślisz',
                items: [],
                description: `wzmacnianie konfiktów między grupami`
            },
            {
                id: 'b4',
                answer: 'możesz być, kim chcesz',
                items: [],
                description: `brak przyzwolenia na mówienie tego, co naprawdę myślimy`
            },   
            {
                id: 'b5',
                answer: 'wartością jest: bycie w kontakcie, nawiązywanie relacji i współpraca',
                items: [],
                description: `wartością jest: konflikt i rywalizacja`
            }           
        ],
        items: [
            {
                value: 'dostrzeganie i akceptowanie różnicy jako faktu'
            },
            {
                value: 'zrozumienie, że wszyscy są ważni i akceptowani we wspólnocie'
            },
            {
                value: 'tworzenie przestrzeni i atmosfery zaufania, w której możesz powiedzieć, co myślisz'
            },
            {
                value: 'możesz być, kim chcesz'
            },
            {
                value: 'wartością jest: bycie w kontakcie, nawiązywanie relacji i współpraca'
            }
        ]
    })

    const completed = useMemo(() => {
        return gameData.baskets.reduce((prev, b) => {
            return prev && (b.answer === b.items[0]);
        }, true);
    }, [gameData.baskets]);

    useEffect(() => {
        if (completed) {
            if (onComplete) onComplete();
        }
    }, [completed, onComplete])

    const onDrop = useCallback((pickupData: string, dropId: string) => {
        moveEgg({ itemId: pickupData, basket: dropId });
    }, [])


    return (
        <div className="task-game-9">
            <div className="drops"> 
                <GameDropZone id="b1" game={gameData} onDrop={onDrop}></GameDropZone>
                <GameDropZone id="b2" game={gameData} onDrop={onDrop}></GameDropZone>               
                <GameDropZone id="b3" game={gameData} onDrop={onDrop}></GameDropZone>
                <GameDropZone id="b4" game={gameData} onDrop={onDrop}></GameDropZone>
                <GameDropZone id="b5" game={gameData} onDrop={onDrop}></GameDropZone>
            </div>
            <div className="picks">
                <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'możesz być, kim chcesz')}></GameElement>
                <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'zrozumienie, że wszyscy są ważni i akceptowani we wspólnocie')}></GameElement>
                <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'dostrzeganie i akceptowanie różnicy jako faktu')}></GameElement>
                <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'wartością jest: bycie w kontakcie, nawiązywanie relacji i współpraca')}></GameElement>
                <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'tworzenie przestrzeni i atmosfery zaufania, w której możesz powiedzieć, co myślisz')}></GameElement>                            
            </div>
        </div>
    )
}

const GameElement: React.FunctionComponent<{ item?: Item, isPickable: boolean }> = ({ item, isPickable }) => {

    return (
        <>
            {item && <div className="game-element">
                {isPickable && <PickUp
                    data={item.value}
                >
                    <span>{item.value}</span>
                </PickUp>}
                {!isPickable && <span>{item.value}</span>}
            </div>

            }
        </>
    )
}

const GameDropZone: React.FunctionComponent<{
    id: string,
    game: GameState,
    onDrop: (pickupData: string, dropId: string) => void;
}> = ({ id, onDrop, game, children }) => {

    const basket = game.baskets.find(b => b.id === id);
    const itemValue = basket?.items[0] || null;
    const item = game.items.find(i => i.value === itemValue) || null;

    const state = useMemo(() => {
        if (!item) {
            return 'empty'
        }

        return basket?.answer === item?.value ? 'correct' : 'wrong';
    }, [basket, item])

    return (
        <div className={`game-drop-zone ${state}`}>
            <div className="inner">
                <p>{basket?.description}</p>
                <DropZone onDrop={onDrop} id={id}>
                    {
                        item && <GameElement item={item} isPickable={true} ></GameElement>
                    }
                    {
                        !item && <GameElement item={{value: 'upuść tutaj'}} isPickable={false}>upuść tutaj</GameElement>
                    }
                </DropZone>
            </div>
        </div>
    )
}

export default TaskGame9;